import React, { PropsWithChildren } from 'react';
import Head from 'next/head';

type SeoProps = {
  seo_html_title: string;
  seo_meta_description: string;
  seo_og_title: string;
  seo_og_description: string;
  seo_og_url: string;
  seo_og_image: string;
  seo_og_type: string;
  seo_twitter_title: string;
  seo_twitter_description: string;
  seo_twitter_url: string;
  seo_twitter_image: string;
  seo_meta_robots: string;
  canonicalLink: string;
};

const defaultSeoProps: Partial<SeoProps> = {};

export type Props = {
  title: string;
  seo: Partial<SeoProps>;
};

function BasePage(props: PropsWithChildren<Props>) {
  const { children, seo = defaultSeoProps, title } = props;

  const {
    seo_html_title: seoHtmlTitle,
    seo_meta_description: seoMetaDescription,
    seo_og_title: seoOgTitle,
    seo_og_description: seoOgDescription,
    seo_og_url: seoOgUrl,
    seo_og_image: seoOgImage,
    seo_og_type: seoOgType,
    seo_twitter_title: seoTwitterTitle,
    seo_twitter_description: seoTwitterDescription,
    seo_twitter_url: seoTwitterUrl,
    seo_twitter_image: seoTwitterImage,
    seo_meta_robots: seoMetaRobots,
    canonicalLink,
  } = seo;

  return (
    <>
      <Head>
        <title>{seoHtmlTitle ?? title}</title>
        <link rel='apple-touch-icon' sizes='180x180' href='/apple-touch-icon.png' />
        <link rel='icon' type='image/png' sizes='32x32' href='/favicon-32x32.png' />
        <link rel='icon' type='image/png' sizes='16x16' href='/favicon-16x16.png' />
        <link rel='manifest' href='/site.webmanifest' />
        <meta name='msapplication-TileColor' content='#da532c' />
        <meta name='theme-color' content='#ffffff' />
        {seoMetaDescription ? <meta name='description' content={seoMetaDescription} /> : null}
        {seoOgTitle ? <meta property='og:title' content={seoOgTitle} /> : null}
        {seoOgDescription ? <meta property='og:description' content={seoOgDescription} /> : null}
        {seoOgUrl ? <meta property='og:url' content={seoOgUrl} /> : null}
        {seoOgImage ? <meta property='og:image' content={seoOgImage} /> : null}
        {seoOgType ? <meta property='og:type' content={seoOgType} /> : null}
        {seoTwitterTitle ? <meta property='twitter:title' content={seoTwitterTitle} /> : null}
        {seoTwitterDescription ? (
          <meta property='twitter:description' content={seoTwitterDescription} />
        ) : null}
        {seoTwitterUrl ? <meta property='twitter:url' content={seoTwitterUrl} /> : null}
        {seoTwitterImage ? <meta property='twitter:image' content={seoTwitterImage} /> : null}
        <meta name='robots' content={seoMetaRobots} />
        {canonicalLink ? <link rel='canonical' href={canonicalLink} /> : null}
      </Head>
      <div className='base-page'>{children}</div>
    </>
  );
}

export default BasePage;
